import { useEffect } from 'react'
import { Box, makeStyles, Tooltip } from '@material-ui/core';
import UtilService from '../../../../helper/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllAnalysisAsync,
  getAsyncImmersionOverall,
  getAsyncSafetyOverall,
  getExcludedParticipantsCallBack,
  getIdentifiers,
  getSessionRange,
  getStimulusAnalysis,
  removeAllGraph,
  removeGraphData
} from '../../../../store/actions/creator/analysis';
import _ from 'underscore';
import { apiClient } from '../../../../config/apiClient';
import AnalysisScoreIcon from '../../creator/analyzeScoreIcon';
import { useStylesTooltip } from "../../../../config/theme";
import { Skeleton } from '@material-ui/lab';
//import { addLogToAws } from '../../../../config/awslog';


const useStyles = makeStyles((theme) => ({
  statuscontent: {
    fontFamily: 'Spartan-bold',
    color: '#697683',
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end"
  },
  statusicon: {
    width: 24,
    height: 24
  },
  statustitle: {
    fontFamily: 'Spartan-bold',
    fontSize: 25,
    color: '#1DB859',
    marginTop: 4
  },
  statustxt: {
    color: '#697683',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    paddingTop: theme.spacing(1),
    textTransform: 'capitalize'
  },
  icon: {
    width: 24,
    height: 24
  },
  tooltipDiv: {
    display: 'flex',
    alignItems: 'center'
  }
}));

interface IProps {
  pathname: string;
  isMobile: boolean;
}

const ExperienceManagerAsyncSection = (props: IProps) => {

  const classes = useStyles();
  const { pathname, isMobile } = props;
  const dispatch = useDispatch();

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const {
    identifiers, currentSession, immersion_overall, safety_overall, stimulus, 
    fingerpulseIdentifiers, fingerpulse, excludedParticipants,
    cliped, all, overviewToKeymoment, tags, isLoadedIdentifiers, settings
  } = useSelector((state: any) => state.analysis);
  const { mqttBackendCalcTime } = settings;
  const { immersionIndex, safetyIndex, fullLoaded } = useSelector((state: any) => state.creatorExperienceManager);
  const {
    scheduled_start_at, scheduled_end_at, session_code, session_status,
    started_at, ended_at, session_type, session_length
  } = currentSession;

  const analysed_start = Math.floor(started_at ? started_at : scheduled_start_at);
  const analysed_end = Math.floor(ended_at ? ended_at : scheduled_end_at);
  const tenant_id = loginUserData.customer_id;

  useEffect(() => {
    dispatch(getIdentifiers(apolloClient.client, session_code, session_type === 'MODERATED'));
    dispatch(getSessionRange(analysed_start, analysed_end));
    const getStimulus = async () => {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${session_code}`);
      dispatch(getStimulusAnalysis(res.data && res.data[0]))
    };
    getStimulus();
  }, []);

  useEffect(() => {
    if (identifiers.length > 0 && stimulus) {

      dispatch(getExcludedParticipantsCallBack(apolloClient.client, session_code, (res: any) => {
        if (res) {
          let _excludedParticipants = res.map((item: any) => item.identifier);
          if(fingerpulse){
            _excludedParticipants = [..._excludedParticipants, ...fingerpulseIdentifiers];
          }

          const allExisted = all.findIndex((item: any) => item.activeParticipant === 'All');

          const request = {
            tenant_id,
            session_code,
            stimulus_id: stimulus?.stimulus_id,
            session_started_at: analysed_start,
            session_completed_at: analysed_end,
            identifiers: _.difference(identifiers, _excludedParticipants),
            from_clip: UtilService.calcVideoEnd(0),
            to_clip: UtilService.calcVideoEnd(stimulus?.stimulus_video_length)
          };

          if (allExisted === -1) {
            setTimeout(() => {
              onCallingAllAsyncData(['All'], _excludedParticipants, 'All', false, false);
            }, 2000);
          } else {
            if (!overviewToKeymoment) {
              onCallingAllAsyncData(['All'], _excludedParticipants, 'All', false, false); // excludeparticiapnts are reculated.
              tags
                .filter((item: any) => all.map((item: any) => item.activeParticipant).includes(item.tagName))
                .map((item: any) => {
                  dispatch(removeGraphData(item['tagName']));
                  onCallingAllAsyncData(_.difference(item['identifiers'], _excludedParticipants), _excludedParticipants, item['tagName'], true, false)
                })
            }
          }
          dispatch(getAsyncSafetyOverall(request));
          dispatch(getAsyncImmersionOverall(request));

        }
      }));
    }
  }, [stimulus && identifiers.length, mqttBackendCalcTime, fingerpulse?.toString()]);


  useEffect(() => {
    const myInterval = setInterval(async () => {
      if (session_status === 'LIVE' && !pathname.includes('/overview') && !isMobile && !fingerpulse) {
        dispatch(getIdentifiers(apolloClient.client, session_code));
        if (identifiers.length > 0 && !cliped && (excludedParticipants.length - identifiers.length < 0)) {
          onCallingAllAsyncData(['All'], [], 'All', false, true);
        }
        if(excludedParticipants.length - identifiers.length >= 0){
          dispatch(removeAllGraph())
        }
      }
    }, 15000);
    return () => {
      clearInterval(myInterval);
    };
  }, [currentSession, identifiers, all, isMobile, fingerpulse, excludedParticipants]);

  const onCallingAllAsyncData = async (_identifiers: string[], _excludedParticipants: string[], name: string, isTag: boolean, backgroundLoading: boolean,) => {
    const request = {
      tenant_id,
      session_code,
      stimulus_id: stimulus?.stimulus_id,
      session_started_at: analysed_start,
      session_completed_at: analysed_end,
      identifiers: (name === 'All') ? _.difference(identifiers, _excludedParticipants) : [..._identifiers],
      from_clip: UtilService.calcVideoEnd(0),
      to_clip: UtilService.calcVideoEnd(stimulus?.stimulus_video_length)
    };
    dispatch(await getAllAnalysisAsync(request, tenant_id, session_code, name, isTag, backgroundLoading,))
  };

  const getScorePane = () => {
    if (cliped) {
      const clipLength = Number(cliped.end_clip - cliped.start_clip);
      return <ScorePane immersion={cliped?.score?.immersion} safety={cliped?.score?.safety}
        session_status={session_status} fullLoaded={fullLoaded || immersion_overall || isLoadedIdentifiers}
        length={clipLength} />
    } else {

      const data = all?.find((item: any) => item.activeParticipant === 'All');
      const immersion = {
        color_indicator: data?.immersion?.overall_color_indicator,
        immersion_index: data?.immersion?.overall_index
      }
      const safety = data?.overall_safety;
      return <ScorePane immersion={data ? immersion : immersion_overall} safety={data ? safety : safety_overall} session_status={session_status}
        fullLoaded={fullLoaded || immersion_overall || isLoadedIdentifiers}
        length={Number(session_length)} />
    }
  };

  return (
    <>
      {!isMobile && (
        <Box className={classes.statuscontent}>
          {(pathname.includes('/overview') && !cliped)
            ? <ScorePane immersion={immersionIndex} safety={safetyIndex} session_status={session_status}
              fullLoaded={fullLoaded || isLoadedIdentifiers} length={Number(session_length)} />
            : getScorePane()
          }
          <Box className={classes.statustxt}>
            {UtilService.formattingString(session_status)}
          </Box>
        </Box>
      )}
    </>
  );
}

export default ExperienceManagerAsyncSection;

function ScorePane(props: any) {
  const { immersion, safety, session_status, fullLoaded, length } = props;
  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  return (
    <Box display="flex" flexDirection="row" justifyContent='flex-end'>
      {immersion ? (
        immersion.color_indicator ? (
          <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
            <Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
              <div className={classes.tooltipDiv}>
                <AnalysisScoreIcon color={immersion.immersion_index > 0 ? immersion.color_indicator : 'gray'} type={'immersion'} size={1} />
                <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.color_indicator) }}>
                  {immersion.immersion_index > 0 ? immersion.immersion_index : '--'}
                </Box>
              </div>
            </Tooltip>
          </Box>
        ) : (
          <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
            <Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
              <div className={classes.tooltipDiv}>
                <AnalysisScoreIcon color={immersion.overall_index > 0 ? immersion.overall_color_indicator : 'gray'} type={'immersion'} size={1} />
                <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(immersion.overall_color_indicator) }}>
                  {immersion.overall_index > 0 ? immersion.overall_index : '--'}
                </Box>
              </div>
            </Tooltip>
          </Box>
        )
      ) : (
        <Box display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
          {(session_status === 'UPCOMING' || fullLoaded || session_status === 'LIVE') ? <Tooltip classes={tooltipClasses} title="Immersion Index: Scale of 1 - 100" placement="bottom" arrow>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={'green'} type={'immersion'} size={1} />
              <Box pl={1} className={classes.statustitle} style={{ color: '#1DB859' }}>--</Box>
            </div>
          </Tooltip>
            : <Skeleton width={50} height={30} />}
        </Box>
      )}
      {(safety && safety.safety_index > 1 && UtilService.isShowSafety('ASYNC', length)) && (
        <Box pl={2} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
          {(session_status === 'UPCOMING' || fullLoaded) ? <Tooltip classes={tooltipClasses} title="Psychological Safety Index: Scale of 1 - 100" placement="bottom" arrow>
            <div className={classes.tooltipDiv}>
              <AnalysisScoreIcon color={safety.color_indicator} type={'safety'} size={1} />
              <Box pl={1} className={classes.statustitle} style={{ color: UtilService.refactorGraphColor(safety.color_indicator) }}>
                {safety.safety_index}
              </Box>
            </div>
          </Tooltip>
            : <Skeleton width={50} height={30} />}
        </Box>
      )}
    </Box>
  )
}